export default __webpack_public_path__ + "static/elf-example-4-9e4baa8e64a4b358965a431f9d67f5fa.png";